import { handleActions } from 'redux-actions'
import { LOCATION_CHANGE } from 'connected-react-router'

import * as type from './type'


export const initialState = {
    salesOrder: null,
    fetching: false,
    error: null,
    hasChanged: false,
    contact: {
        id: null,
        gender: null,
        firstName: null,
        lastName: null,
        streetAddress: null,
        streetAddressExtension: null,
        staircase: null,
        door: null,
        zip: null,
        city: null,
        countryCode: null,
        email: null,
        phone: null,
        dob: null,
    },
}

export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...state,
            salesOrder: null,
            fetching: false,
        }
    },
    [type.FIND_SALES_ORDER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            salesOrder: null,
        }
    },
    [type.FIND_SALES_ORDER_SUCCESS]: (state, action) => {
        const { salesOrder } = action.payload
        return {
            ...state,
            salesOrder,
            fetching: false,
        }
    },
    [type.FIND_SALES_ORDER_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_SALES_ORDER_CUSTOMER]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            salesOrder: {
                ...state.salesOrder,
                salesOrderCustomer: {
                    ...state.salesOrder.salesOrderCustomer,
                    [name]: value,
                },
            },
            hasChanged: true,
        }
    },
    [type.SAVE_SALES_ORDER_CUSTOMER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_SALES_ORDER_CUSTOMER_SUCCESS]: (state, action) => {
        const { salesOrderCustomer } = action.payload
        return {
            ...state,
            fetching: false,
            hasChanged: false,
            salesOrder: {
                ...state.salesOrder,
                salesOrderCustomer,
            },
        }
    },
    [type.SAVE_SALES_ORDER_CUSTOMER_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

    [type.CHANGE_SALES_ORDER]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            salesOrder: {
                ...state.salesOrder,
                [name]: value,
            },
            hasChanged: true,
        }
    },
    [type.SAVE_SALES_ORDER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_SALES_ORDER_SUCCESS]: (state, action) => {
        const { salesOrder } = action.payload
        return {
            ...state,
            salesOrder,
            fetching: false,
            hasChanged: false,
        }
    },
    [type.SAVE_SALES_ORDER_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.ADD_SENT_EMAIL]: (state, action) => {
        const { sentEmail } = action.payload
        return {
            ...state,
            salesOrder: {
                ...state.salesOrder,
                sentEmailList: [
                    ...state.salesOrder.sentEmailList,
                    sentEmail,
                ],
            },

        }
    },
    [type.ADD_INVOICE]: (state, action) => {
        const { invoice } = action.payload
        return {
            ...state,
            salesOrder: {
                ...state.salesOrder,
                invoiceList: [
                    ...state.salesOrder.invoiceList,
                    invoice,
                ],
            },
        }
    },
    [type.ADD_SHIPMENT]: (state, action) => {
        const { shipment } = action.payload
        return {
            ...state,
            salesOrder: {
                ...state.salesOrder,
                shipmentList: [
                    ...state.salesOrder.shipmentList,
                    shipment,
                ],
            },
        }
    },
    [type.HYDRATE_SALESORDER_CUSTOMER_CONTACT]: (state, action) => {
        const {salesOrder} = state
        const {salesOrderCustomer} = salesOrder
        return {
            ...state,
            contact: {
                id: salesOrderCustomer.id,
                gender: salesOrderCustomer.gender,
                firstName: salesOrderCustomer.firstName,
                lastName: salesOrderCustomer.lastName,
                streetAddress: salesOrderCustomer.streetAddress,
                streetAddressExtension: salesOrderCustomer.streetAddressExtension,
                staircase: salesOrderCustomer.staircase,
                door: salesOrderCustomer.door,
                zip: salesOrderCustomer.zip,
                city: salesOrderCustomer.city,
                countryCode: salesOrderCustomer.countryCode,
                email: salesOrderCustomer.email,
                phone: salesOrderCustomer.phone,
                dob: salesOrderCustomer.dob,
            }
        }
    },
    [type.CHANGE_SALES_ORDER_CUSTOMER_CONTACT]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            hasChanged: true,
            contact: {
                ...state.contact,
                [name]: value,
            },
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/detail/reducer.js